import { useTranslation } from 'react-i18next';
import LockIcon from '@/lib/assets/lock.svg';
import styles from './PaymentHeader.module.scss';

const PaymentHeader = ({ title = 'paymentCheckout' }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.header}>
            <div className={styles.header_content}>
                <h3 className={styles.bluetext}>{t(title)}</h3>
                <div>
                    <LockIcon alt='lock' className={styles.lock_icon} />
                    <p>{t('securePayment')}</p>
                </div>
            </div>
        </div>
    );
};

export default PaymentHeader;
